import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { setRangeValue } from "../../Utils/NumberUtils";
export var AnimationOptions = /*#__PURE__*/function () {
  function AnimationOptions() {
    _classCallCheck(this, AnimationOptions);
    this.count = 0;
    this.enable = false;
    this.speed = 1;
    this.sync = false;
  }
  _createClass(AnimationOptions, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.count !== undefined) {
        this.count = setRangeValue(data.count);
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.speed !== undefined) {
        this.speed = setRangeValue(data.speed);
      }
      if (data.sync !== undefined) {
        this.sync = data.sync;
      }
    }
  }]);
  return AnimationOptions;
}();